<template>
  <translate :tt="{ count }">
    {count, plural, one{# option matches} other{# options match}} your search
    criteria...
  </translate>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class MatchingCriteriaCountText extends Vue {
  @Prop({ required: true })
  count: number
}

export default toNative(MatchingCriteriaCountText)
</script>
